/**
 * useAuth
 *
 * Neden: Component'ler authStore'un iç yapısını bilmesin — `auth` namespace + `isAuthenticated`
 * türetmesi tek bir yerden sağlansın. İlerde backend entegrasyonu geldiğinde token doğrulama /
 * refresh mantığı burada merkezileşir.
 */
import { useAuthStore } from '@/stores/auth-store'

export function useAuth() {
  const { auth } = useAuthStore()

  // Token var AND (kullanıcı yok -> token geçerliliği backend'e bırakılır) ||
  // kullanıcının `exp` alanı varsa şu ana göre kontrol edilir.
  const hasToken = Boolean(auth.accessToken)
  const notExpired = auth.user?.exp ? auth.user.exp > Date.now() : true
  const isAuthenticated = hasToken && notExpired

  return {
    user: auth.user,
    accessToken: auth.accessToken,
    isAuthenticated,
    setUser: auth.setUser,
    setAccessToken: auth.setAccessToken,
    signOut: auth.reset,
  }
}

/**
 * Non-reactive auth snapshot.
 * Neden: TanStack Router `beforeLoad` gibi component dışı çağrılarda `useAuth` kullanılamaz —
 * store'un mevcut değerine doğrudan erişim gerekir.
 */
export function getAuthSnapshot() {
  const { auth } = useAuthStore.getState()
  const hasToken = Boolean(auth.accessToken)
  const notExpired = auth.user?.exp ? auth.user.exp > Date.now() : true
  return {
    user: auth.user,
    accessToken: auth.accessToken,
    isAuthenticated: hasToken && notExpired,
  }
}
